import { OrgConfigs, useOrgConfig } from './useOrgConfig';

export const useCanAlignEvaluators = (): {
  isLoading: boolean;
  areEvaluatorsAlignable: boolean;
  newRuleEvaluatorVersion: number;
} => {
  const newRuleEvaluatorVersionPayload = useOrgConfig(
    OrgConfigs.new_rule_evaluator_creation_version
  );
  const newRuleEvaluatorVersion = newRuleEvaluatorVersionPayload?.value;
  return {
    isLoading: newRuleEvaluatorVersionPayload.isLoading,
    areEvaluatorsAlignable: isEvaluatorVersionAlignable(
      newRuleEvaluatorVersion
    ),
    newRuleEvaluatorVersion:
      newRuleEvaluatorVersion != null ? Number(newRuleEvaluatorVersion) : 2,
  };
};

export const isEvaluatorVersionAlignable = (
  version: string | number | boolean | null
): boolean => {
  const newRuleEvaluatorVersionNumeric =
    version != null ? Number(version) : null;
  return (newRuleEvaluatorVersionNumeric ?? 0) >= 3;
};
